const loadMoreBtns = document.querySelectorAll('.js-load-more');

loadMoreBtns.forEach(btn => {
  btn.addEventListener('click', async () => {
    const nextUrl = btn.dataset.nextUrl;
    const gridSelector = btn.dataset.grid;
    const grid = document.querySelector(gridSelector);

    if (!nextUrl || !grid) return;

    const originalText = btn.textContent.trim();
    btn.disabled = true;
    btn.textContent = '…';

    try {
      const response = await fetch(nextUrl);
      const html = await response.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');

      // Append new article cards to the existing grid
      const newCards = doc.querySelectorAll('#articles-grid > div');
      newCards.forEach(card => grid.appendChild(card));

      // Reinitialise lazysizes on newly added images
      if (window.lazySizes) {
        document.querySelectorAll('.lazyload').forEach(el => {
          el.classList.remove('lazyloaded');
          el.classList.add('lazyload');
        });
      }

      // Update button with the next page URL from the fetched page, or hide if last page
      const newBtn = doc.querySelector('.js-load-more');
      if (newBtn && newBtn.dataset.nextUrl) {
        btn.dataset.nextUrl = newBtn.dataset.nextUrl;
        btn.disabled = false;
        btn.textContent = originalText;
      } else {
        const container = document.getElementById('load-more-container');
        if (container) container.remove();
      }
    } catch (err) {
      btn.disabled = false;
      btn.textContent = originalText;
      console.error('Failed to load more articles:', err);
    }
  });
});
